var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"double-scrollbar"},[_c('div',{ref:"topScroll",staticClass:"top-scroll"},[_c('div',{ref:"scrollBar",staticClass:"scrollBar",style:(_vm.scrollBarStyle)},[_vm._v(" ")])]),_c('div',{ref:"scrollArea",staticClass:"scroll-area"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }